import { apiRequest } from './client.js';
import type { GraphEmployee } from './graph.js';

export async function syncLocationEmployees(
  locationId: string,
  employees: GraphEmployee[],
): Promise<void> {
  await apiRequest('POST', `/locations/${encodeURIComponent(locationId)}/employees/sync`, {
    employees,
  });
}
